<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template>
            <div class="container-fluid xyz">
                <!--page content-->
                <div class="admin-page-content">
                    <div class="page-title-container">
                        <div class="page-name">Location Manager</div>
                        <div class="pagebutton">
                            <router-link class="themebutton" title="Add" v-bind:to="{name: 'AddUpdateLocationManager'}">
                                <span>Add</span>
                            </router-link>
                        </div>
                    </div>
                    <div class="pl-0 pr-0 col-md-12 forms-block">
                        <div class="pl-0 col-md-6 col-sm-12 forms-block pr-0 pull-left">
                            <div class="mt-2 pull-left pr-0 pl-0 col-3 paddingleft0">
                                <!-- <div class="form-label">Request Options :</div> -->
                            </div>
                            <div class="pull-right pr-0 pl-0 col-9 paddingleft0">
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                    <!-- <br/> -->
                    <vue-good-table
                        ref="LocationManagerList"
                        mode="remote"
                        title="Location Manager"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'bottom',
                            perPage: serverParams.perPage,
                            setCurrentPage: serverParams.setCurrentPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                        }"
                        :search-options="{
                            enabled: false,
                        }">
                        <!-- Custome Pagination -->
                        <template slot="pagination-bottom" slot-scope="props">
                            <div class="vgt-wrap__footer crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            class="pagination-select-box"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->
                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action'" class="table-action">
                                        <router-link title='Edit' class="btn edit-btn-vvg waves-effect pull-left" v-bind:to="{name: 'AddUpdateLocationManager', params:{id: props.row.id}}">
                                            <i class="fa fa-pencil" aria-hidden="true"></i>
                                        </router-link>
                                        <a href="javascript:void(0)" @click="deleteData(props.row.id)" title='Delete' class="btn edit-btn-vvg waves-effect pull-left">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </a>
                                </div>
                                <div v-else>
                                    {{props.formattedRow[props.column.field]}}
                                </div>
                            </div>
                        </template>
                        <div slot="selected-row-actions">
                            <template>
                            </template>
                        </div>
                    </vue-good-table>   
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Footer from "@/components/partials/Footer";
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import EventBus from "../event-bus";
    // import NoAccessPage from "@/components/NoAccessPage/NoAccessPage";
    Vue.component("app-footer", Footer);
    // Vue.component('no-access', NoAccessPage);
    Vue.use(VueGoodTable);
    var app;
    export default {
        name: 'LocationManager',
        components: {
        },
        mixins: [commonMixins],
        data() {
            return {
                loginUserRoleId: 1,
                firstLoad: 0,
                formMasterArr: [],
                columns: [
                    {
                        label: 'Location Name',
                        field: 'name',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Location Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        } 
                    },
                    {
                        label: 'Form Type',
                        field: 'form',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Form Type", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        } 
                    },
                    {
                        label: 'Excede Loc. Id',
                        field: 'excede_location_id',
                        filterable: true,
                        sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Excede Loc. Id", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Display Order',
                        field: 'display_order',
                        filterable: false,
                        sortable: true,
                        // filterOptions: {
                        //     enabled: true, // enable filter for this column
                        //     placeholder: "Display Order", // placeholder for filter input
                        //     filterValue: '', // initial populated value for this filter
                        //     filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        //     filterFn: this.onColumnFilter, //custom filter function that
                        //     trigger: "enter" //only trigger on enter not on keyup
                        // }
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        filterable: true,
			            sortable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                        width: '108px',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                    perPageDropdown : [],
                },
                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
            }
        },
        watch: {
        },
        created: function () {
        },
        beforeMount: function () {
            app = this;
        },
        mounted: function () {
            app.setActiveMenu("location-manager");
            EventBus.$emit("menu-selection-changed", "location-manager");
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var userJson = JSON.parse(userObj);
            }

            app.jumpToPageTask = app.serverParams.page;
            app.pageCompareTask = Math.ceil(app.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    app.jumpToInputPageTask(app.jumpToPageTask)
                }
            });

            app.serverParams.perPageDropdown.push(25);
            app.serverParams.perPageDropdown.push(50);
            app.serverParams.perPageDropdown.push(100);
            app.serverParams.perPageDropdown.push(200);
            app.serverParams.perPageDropdown.push(500);
            app.laodLocationManagerData();
        },
        methods: {
            jumpToPageInTask: function (e) {
                app.jumpToInputPageTask(app.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                app.jumpToInputPageTask(app.serverParams.page);
                app.laodLocationManagerData();
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = app.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - app.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > app.pageNumberListTask()) {
                    pageNumber = app.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(app.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                app.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                app.serverParams.page = pageNumber;
                app.jumpToPageTask = pageNumber;
                app.laodLocationManagerData();
            },
            updateParams(newProps) {
                app.serverParams = Object.assign({}, app.serverParams, newProps);
            },
            onPageChange(params) {
                app.updateParams({page: params.currentPage});
                app.laodLocationManagerData();
            },
            onPerPageChange(params) {
                if (params.currentPerPage != app.serverParams.perPage) {
                    app.updateParams({perPage: params.currentPerPage});
                    app.totalRecords = app.totalRecords;
                    app.laodLocationManagerData();
                }
            },
            onColumnFilter(params) {
                app.updateParams(params);
                {
                    field: ('id');
                    field: ('name');
                    field: ('form');
                    field: ('excede_location_id');
                    field: ('display_order');
                    field: ('updated_at');
                };
                app.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(app.serverParams));
                var filters = filtersPr.columnFilters;

                if (app.firstLoad == 1 || filters.id || filters.name || filters.form || filters.excede_location_id
                    || filters.display_order || filters.updated_at) {
                    app.laodLocationManagerData();
                }
            },
            selectionChanged() {
                app.selectedRows = (app.$refs['LocationList'].selectedRows).length;
                /* console.log(app.selectedRows); */
            },
            onSortChange(params) {
                app.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                app.laodLocationManagerData();
            },
            deleteData: function(id) {
                let deleteArray = [];
                id = (id === null || typeof (id) === "undefined" || id == '' || id == 0) ? 0 : id;
                if(id != 0) {
                    deleteArray.push(id);
                } else {
                    var parRequestDeleteArr = [];
                    var selectedPARRequest = this.$refs["LocationManagerList"].selectedRows;
                    for (var i = 0; i < selectedPARRequest.length; i++) {
                        parRequestDeleteArr.push(this.$refs["LocationManagerList"].selectedRows[i].id);
                    }
                    deleteArray = parRequestDeleteArr;
                }
                app.$swal({
                    title: '',
                    text: 'Are you sure that you want to delete this Location(s)!',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                            data : {
                                deleteArr: deleteArray,
                            }
                        };
                        HTTP.delete("/location/manager/delete", config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    app.laodLocationManagerData();
                                }
                            })
                            .catch(function (error) {
                                app.catchHandler(err, function () {});
                            });
                    }
                });
            },
            laodLocationManagerData() {
                app.firstLoad = 1;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var fields = {
                    page: app.serverParams.page,
                    perPage: app.serverParams.perPage,
                    filters: app.serverParams.columnFilters,
                    sort: app.serverParams.sort,
                };
                app.showLoader();
                HTTP.post("/location/manager/get", fields, config)
                    .then(function (response) {
                        // console.log(response);
                        if (response.data.code == '200') {
                            app.rows = response.data.content.row;
                            app.totalRecords = response.data.content.totalRecords;
                        }
                        app.paginationDisplayRowsTask = app.getRecords(app.serverParams.page, app.serverParams.perPage, app.totalRecords);
                        app.hideLoader();
                    })
                    .catch(function (err) {
                        app.hideLoader();
                        app.catchHandler(err, function () {});
                    });
            },
        },
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/LocationManager/LocationManager.vue